export default {"src":"/_next/static/media/chevronUp_24.5f14731e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};